import axios from 'axios';
import { toast } from 'sonner';

export const api = axios.create({
	baseURL: import.meta.env.VITE_BACK_URL,
	withCredentials: true,
});

api.interceptors.response.use(
	response => response,
	(error: unknown) => {
		let message = 'Неизвестная ошибка';

		if (axios.isAxiosError(error)) {
			message = error?.response?.data?.message ?? error?.message;
			toast.error(message);
		}

		return Promise.reject(error);
	}
);
